module.exports = __webpack_public_path__ + "static/core-innovation-capital-a67f7bda12141166fcff0a970cde9b8e.png";